import { getClosetGroupsManagers } from 'api/groups/closet';
import { useEffect, useState } from 'react';
import { CLOSETGroupsManager, GetCLOSETGroupsManagersResponse } from 'types/api/groups/closet';

interface Props {
  managerEmail: string | null;
  setManager: (manager: CLOSETGroupsManager | null) => void;
}

export const useCLOSETGroupsManagersQuery = (props: Props) => {
  const [managerOptions, setManagerOptions] = useState<GetCLOSETGroupsManagersResponse>([]);

  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const emails = await getClosetGroupsManagers();
        setManagerOptions(emails);
        if (props.managerEmail) {
          props.setManager(emails.find(item => item.email === props.managerEmail) || null);
        }
      } catch (error) {
        console.error('Error fetching groups managers:', error);
      }
    };
    void fetchManagers();
  }, []);

  const getManagerLabel = (data: CLOSETGroupsManager): string => {
    return data.email;
  };

  return { data: managerOptions, getManagerLabel };
};
